import { useApiQuery } from '../../api/useApi';
import type { Facility } from '../../pages/settings/facilities/useFacility';

/**
 * Les établissements que l'utilisateur peut sélectionner.
 *
 * Cinq lignes plutôt que l'import de `useFacilityWithChildren` : ce hook-là vit
 * dans `pages/settings/facilities/useFacility.ts`, que la frontière du socle
 * interdit d'atteindre (#23). Le corriger voudrait dire extraire un hook d'un
 * fichier de 250 lignes du web, pour un appel `useApiQuery` d'une ligne — on
 * duplique, comme le veut la règle sur les chemins critiques.
 *
 * L'endpoint et la forme de réponse sont les mêmes que ceux du sélecteur web
 * (`FacilitySwitcherModal`), `GET /facilities/{id}/with-children`.
 */
type GroupeAvecEnfants = Facility & { child_facilities?: Facility[] };

export function useFacilitesDuGroupe(idGroupe: number | null) {
    return useApiQuery<GroupeAvecEnfants>(
        idGroupe ? `/facilities/${idGroupe}/with-children` : '',
        {},
        { enabled: Boolean(idGroupe) },
    );
}
